import React from 'react';
import { Container, Row, Col, ListGroup } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import CrapSpreader1 from '../images/crap_spreader1lores.jpg';
import CrapSpreader2 from '../images/crap_spreader2lores.jpg';
import CrapSpreader3 from '../images/crap_spreader3lores.jpg';

const MachineControl = () => {
        return (
            <>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>SOFTAC | Engenious Machine Control</title>
                    <link rel="canonical" href="https://www.softac.com/machine-control" />
                    <meta name="description" content="Programming logic and custom remote machine controls including the internet of things." />
                </Helmet>

                <div className="page-shell">
                <Container>
                    <h1 className="header-highlight">Engenious Machine Control</h1>
                    <Row className="justify-content-md-center text-left">
                        <Col md="12">
                            <section className="info-section">
                                <h2>Summary</h2>
                                <img src={CrapSpreader1} alt="Agricultural Spreader" className="mc-image mc-image-right" />
                                <p>Over the past number of years Softac has developed and has been refining a series of remote control systems that
                                can be utilized in a host of different applications.  Our “sweet spot” is in applications that require remote monitoring
                                and remote control of engines and hydraulics.  Utilizing cellular communications, you can access your equipment from any
                                web enabled device located anywhere in the world.   Softac utilizes ultra low bandwidth communication methodologies,
                                keeping your monthly data subscription to a minimum, and utilizes state of the art technology to offer you a graphically
                                rich and extremely intuitive user interface where you can monitor and control all aspects of your equipment.</p>
                            </section>

                            <section className="info-section">
                                <ListGroup>
                                    <div><h4>High level specifications:</h4></div>
                                    <ListGroup.Item className="cardstyles">12vdc and 24vdc applications. We can also incorporate 120VAC for stationary applications</ListGroup.Item>
                                    <ListGroup.Item className="cardstyles">Cellular - 3G, 4G, 5G and LTE </ListGroup.Item>
                                    <ListGroup.Item className="cardstyles">NEMA 4X Polycarbonate enclosure</ListGroup.Item>
                                    <ListGroup.Item className="cardstyles">Vibration isolators</ListGroup.Item>
                                    <ListGroup.Item className="cardstyles">CANbus J1939, CANopen, Ethernet IP,and MODbus</ListGroup.Item>
                                    <ListGroup.Item className="cardstyles">On board I/O for monitoring Fuel level, pressures, temperatures and control of valves, lights, etc.</ListGroup.Item>
                                    <ListGroup.Item className="cardstyles">Ability to connect more than one system together to work seamlessly over cellular networks</ListGroup.Item>
                                    <ListGroup.Item className="cardstyles">Complete elimination of traditional Murphy panels, further reducing your cost & complexity</ListGroup.Item>
                                </ListGroup>
                            </section>

                            <section className="info-section">
                                <ListGroup>
                                    <div><h4>Applications/use cases:</h4></div>
                                    <ListGroup.Item className="cardstyles">Water, effluent and agricultural pumping applications</ListGroup.Item>
                                    <ListGroup.Item className="cardstyles">Any industrial equipment requiring remote access</ListGroup.Item>
                                </ListGroup>
                            </section>

                            <div className="mc-image-row">
                                <img src={CrapSpreader3} alt="Agricultural Spreader" className="mc-image" />
                                <img src={CrapSpreader2} alt="Agricultural Spreader" className="mc-image" />
                            </div>
                        </Col></Row>
                </Container>
                </div>

            </>

        )
}

export default MachineControl;
